import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import type { MeasurementUnit } from '../models/measurement-unit.model';
import { environment } from '../../../environments/environment';

type MeasurementUnitResponse = Record<string, MeasurementUnit>;

@Injectable({
  providedIn: 'root'
})
export class MeasurementUnitService {
  constructor(private http: HttpClient) {}

  public loadMeasurementUnits(): Observable<MeasurementUnitResponse> {
    return this.http.get<MeasurementUnitResponse>(`${environment.apiUrl}/config/measurement-units`);
  }
}
